import { Form } from "react-bootstrap";
import "../style/Checkbox.css";

const Checkbox = (props) => {
  return (
    <div className="checkbox">
      <Form.Check
        value={props.value}
        checked={props.checked}
        onChange={props.onChange}
        onClick={props.onClick}
        label={props.label}
      />
    </div>
  );
};

export default Checkbox;
